import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';

import { AppState } from 'services/types';
import { ProductId } from 'services/products/types';
import { OwnProps } from './index';
import { selectFertilizerWorksheetProductsKeyedById } from '../../../../selectors';

const selectProductId = (state: AppState, props: OwnProps): ProductId =>
    props.productId;

const selectProductWitholdingPeriodDays = createDeepEqualSelector(
    selectFertilizerWorksheetProductsKeyedById,
    selectProductId,
    (productsKeyedById, productId) =>
        get(productsKeyedById, [
            productId,
            'fertilizerProduct',
            'witholdingPeriodDays'
        ])
);

const makeSelectProductWitholdingPeriodDays =
    (): typeof selectProductWitholdingPeriodDays =>
        selectProductWitholdingPeriodDays;

export { selectProductId, makeSelectProductWitholdingPeriodDays };
